<template>
  <span
    class="ds-badge"
    :class="variant"
  >
    <slot />
  </span>
</template>

<script>
export const DS_BADGE_VARIANTS = ['neutral', 'accent', 'wine', 'success', 'danger']

export default {
  name: 'DsBadge',
  props: {
    variant: {
      type: String,
      default: 'neutral',
      validator: value => DS_BADGE_VARIANTS.includes(value),
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/design-system/mixins';

.ds-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px;
  border-radius: 100px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.45;
  white-space: nowrap;

  &.neutral {
    background: $c-bg;
    border: 1px solid $c-border;
    color: $c-text-sec;
  }

  &.accent {
    background: rgba($c-orange, 0.08);
    border: 1px solid rgba($c-orange, 0.33);
    color: $c-orange;
  }

  &.wine {
    background: $c-wine-light;
    border: 1px solid rgba($c-wine, 0.14);
    color: $c-wine;
  }

  &.success {
    background: $c-success-light;
    border: 1px solid rgba($c-success, 0.25);
    color: #1f7a45;
  }

  &.danger {
    background: $c-danger-light;
    border: 1px solid rgba($c-danger, 0.19);
    color: $c-danger-text;
  }
}
</style>
